import store from '@ps/store'

export type MoveNodeActionValue = {
  oldValue: {
    id: string
    x: number
    y: number
  }
  newValue: {
    id: string
    x: number
    y: number
  }
}
export const getMoveNodeAction = (value: MoveNodeActionValue) => {
  return {
    execute: ({ newValue }: MoveNodeActionValue) => {
      const { id } = newValue
    },
    undo: ({ oldValue }: MoveNodeActionValue) => {
      const { id } = oldValue
    },
    value,
  }
}

export const getSwitchToStoryBoardAction = (value: unknown) => {
  return {
    execute: () => {
      store.dispatch('workspace/storyboard/switchToStoryBoard')
    },
    undo: () => {
      store.dispatch('workspace/storyboard/switchToSingleView')
    },
    value,
    methodName: 'getSwitchToStoryBoardAction',
  }
}
export const getSwitchToSingleViewAction = (value: unknown) => {
  return {
    execute: () => {
      store.dispatch('workspace/storyboard/switchToSingleView')
    },
    undo: () => {
      store.dispatch('workspace/storyboard/switchToStoryBoard')
    },
    value,
    methodName: 'getSwitchToSingleViewAction',
  }
}
